export default __webpack_public_path__ + "static/media/light-active.40123a5e.png";